// extracted by mini-css-extract-plugin
export var messageSideLeft = "_gr-1";
export var messageSideRight = "_gr-2";
export var subscribeToBackInStockBubbleContainer = "_gr-0";